import PropTypes from 'prop-types'
import ArticlesSlider from '@components/articles-slider'
import Grid from '@material-ui/core/Grid'
import CoachesSearchSection from '@components/coaches-search-section-v2'
import React from 'react'
import useStyles from './match-play-content-section.styles'

const MatchPlayContentSection = (props) => {
  const {
    findCoachTitle,
    findCoachSubtitle,
    findCoachCta,
    articles,
    isEmbedView,
  } = props
  const styles = useStyles()

  return (articles?.length > 0 && !isEmbedView) && (
    <Grid container className={styles.root}>
      <Grid item xs={12} md={8}>
        <ArticlesSlider
          articles={articles}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <CoachesSearchSection
          title={findCoachTitle}
          description={findCoachSubtitle}
          cta={findCoachCta}
          coachCardClass="coachingChannel"
        />
      </Grid>
    </Grid>
  )
}

MatchPlayContentSection.propTypes = {
  findCoachTitle: PropTypes.string,
  findCoachSubtitle: PropTypes.string,
  findCoachCta: PropTypes.string,
  articles: PropTypes.arrayOf(PropTypes.object),
  isEmbedView: PropTypes.bool,
}

export default MatchPlayContentSection
